/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { KakaoService } from './services/kakao.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { ReservationService } from './services/reservation.service';
import { RecommendedProductService } from './services/recommended-product.service';
import { ProductService } from './services/product.service';
import { MagazineOfTheMonthService } from './services/magazine-of-the-month.service';
import { MagazineService } from './services/magazine.service';
import { CategoryService } from './services/category.service';
import { FileService } from './services/file.service';
import { InquiryService } from './services/inquiry.service';
import { FaqService } from './services/faq.service';
import { BusinessInfoService } from './services/business-info.service';
import { BannerService } from './services/banner.service';
import { NoticeService } from './services/notice.service';
import { UserService } from './services/user.service';
import { GalleryService } from './services/gallery.service';
import { AuthenticationService } from './services/authentication.service';
import { LikeService } from './services/like.service';
import { CommentService } from './services/comment.service';
import { TermsService } from './services/terms.service';
import { ReviewService } from './services/review.service';
import { AdminService } from './services/admin.service';
import { MemoService } from './services/memo.service';
import { NotificationService } from './services/notification.service';
import { StatisticsService } from './services/statistics.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    KakaoService,
    GoogleAnalyticsService,
    ReservationService,
    RecommendedProductService,
    ProductService,
    MagazineOfTheMonthService,
    MagazineService,
    CategoryService,
    FileService,
    InquiryService,
    FaqService,
    BusinessInfoService,
    BannerService,
    NoticeService,
    UserService,
    GalleryService,
    AuthenticationService,
    LikeService,
    CommentService,
    TermsService,
    ReviewService,
    AdminService,
    MemoService,
    NotificationService,
    StatisticsService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
